<template>
    <div class="addtemplate">
        <div class="head-title">
            <div class="back" @click="backOrdrTemplate">
                <span><i class="el-icon-arrow-left" style="font-size: 17px;font-weight: 400"></i></span>
                <span class="backTem" >返回工单模板</span>
            </div>
            <div class="addOrder">
                <div v-if="!this.$route.query.id">新增工单模板</div>
                <div v-if="this.$route.query.id">修改工单模板</div>
            </div>
            <div class="btn">
                    <el-button size="small" @click="closeClick">关闭</el-button>
                    <el-button type="primary" size="small" @click="addWorkOrderTemplate" v-if="!this.$route.query.id">保存</el-button>
                <el-button type="primary" size="small" @click="modifyWorkOrderTemplate"  v-if="this.$route.query.id">修改</el-button>
            </div>
        </div>
            <div class="addTemcontain">
                <div class="containLeft">
                    <side-bar>
                            <div slot="filter">
                                <div class="filed"><span style="font-size: 14px">字段</span><span style="color: #cccccc;font-size: 12px;">(点击字段即可添加到模板)</span></div>
                            </div>
                            <div slot="scrollbar" class="siderList" style="height: 500px" id="fieldList">
                                <div @click="filedTypeClick(item.type,index,item.id,item)" class="presetFields" v-for="(item,index) in filed.list" :key="item.id">
                                    <span class="text">{{item.name}}</span>
                                  <!--  <span class="icon" style="cursor: move"><img class="decImg" src="../../../assets/images/workorder/adjust1.png" @mouseenter="resortField"/></span>-->
                                </div>
                            </div>
                            <div slot="defaultfilter"></div>
                    </side-bar>
                </div>
                <div class="containRight">
                    <el-scrollbar style="height:100%">
                        <div class="addTemplateScroll">
                                <div class="top">
                                    <div class="tempName">
                                        <div class="tempNameText"><span style="color: red">*</span><span style="font-size: 14px">模板名称</span></div>
                                        <div class="tempNameInput">
                                            <el-input
                                                    placeholder="请输入内容"
                                                    v-model="templateName"
                                                    clearable
                                                    maxlength="10"
                                            >
                                            </el-input>
                                        </div>
                                    </div>
                                    <div class="temDec">
                                        <div class="temDecText" style="font-size: 14px">模板描述</div>
                                        <div class="temDecInput">
                                            <el-input
                                                    placeholder="请输入内容"
                                                    v-model="templateDescribe"
                                                    clearable>
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                    <el-divider></el-divider>
                          <div class="tooptip">
                            <el-alert
                                title="模板字段可配置默认值，配置好了默认值后，在新增工单或通过对话提交工单时，会将默认值自动填写到对应字段中，优先级：模版默认值>字段默认值"
                                type="warning"
                                :closable="false">
                            </el-alert>

                          </div>
                    <div class="main" >
                            <div class="theme">
                                            <div class="move" >
                                                <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position:absolute;top: 50%;left: 50%"/>
                                            </div>

                                            <div class="themeContain">
                                                <div class="themeText">
                                                    <div style="font-size: 14px">主题</div>
                                                    <div class="checked">
                                                        <el-checkbox v-model="checked" disabled>必填</el-checkbox>
                                                    </div>
                                                    <div class="delIcon" disabled="disabled">
                                                        <img src="../../../assets/images/workorder/delete.png" class="delImg" />
                                                    </div>
                                                </div>
                                                <div class="inputText">
                                                    <el-input
                                                            placeholder="请输入内容"
                                                            v-model="inputName"
                                                            clearable
                                                            style="width: 100%;"
                                                    >
                                                    </el-input>
                                                </div>
                                            </div>
                            </div>
                    </div>
                    <div class="addTemDec">
                        <div class="addtemplateDec">
                            <div class="addTemDecIcon">
                                <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;bottom: 0;right: 0"/>
                            </div>
                            <div class="decContain">
                                <div class="addTemplateDescribe">
                                    <div style="font-size: 14px">描述</div>
                                    <div class="Decchecked">
                                        <el-checkbox v-model="checked1" disabled>必填</el-checkbox>
                                    </div>
                                    <div class="delIcon">
                                        <img src="../../../assets/images/workorder/delete.png" class="delImg"/>
                                    </div>
                                </div>

                                <div class="addTemquill">
                                    <vue-ueditor-wrap v-model="addTemplateDescribe" :config="myConfig"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="addTemplatOneTwo">
                                <div class="addTemplateOne">
                                    <div class="addTempCustom">
                                        <div class="customIcon">
                                            <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position: absolute;left: 50%;" />
                                        </div>
                                        <div class="customContain">
                                            <div class="customManage">
                                                <div style="font-size: 14px">客户</div>
                                                <div>
                                                    <el-checkbox v-model="customerCheck">必填</el-checkbox>
                                                </div>
                                                <div class="delIcon">
                                                    <img src="../../../assets/images/workorder/delete.png" class="delImg"/>
                                                </div>
                                            </div>
                                            <div class="addTemCustomSelect">
                                                <el-select
                                                    v-model="addCustomSelect"
                                                    placeholder="请选择"
                                                    clearable
                                                    style="width: 96%">
                                                    <el-option
                                                            v-for="item in client.list"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </div>

                                        </div>


                                    </div>


                                    <div class="addTemgroup">

                                        <div class="addTemGroupIcon">
                                            <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position:absolute;left: 50%"/>
                                        </div>
                                        <div class="addTemGroupContain">
                                            <div class="groupManage">
                                                <div style="font-size: 14px">受理组</div>
                                                <div>
                                                    <el-checkbox v-model="groupCheck">必填</el-checkbox>
                                                </div>
                                                <div class="delIcon">
                                                    <img src="../../../assets/images/workorder/delete.png" class="delImg"/>
                                                </div>
                                            </div>
                                            <div class="ddTemGroupSelect">
                                                <el-select v-model="addgroupSelect"
                                                           placeholder="请选择"
                                                           style="width: 96%;"
                                                           clearable
                                                           @change="getAccountPerson"
                                                >
                                                    <el-option
                                                            v-for="item in accountGroup.list"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id"

                                                    >
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="addTemperson">
                                        <div class="addTemPersonIcon">
                                            <img  src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position: absolute;left: 50%"/>
                                        </div>
                                        <div class="addTemPersonContain">
                                            <div class="personManage">
                                                <div style="font-size: 14px">受理人</div>
                                                <div>
                                                    <el-checkbox v-model="personCheck">必填</el-checkbox>
                                                </div>
                                                <div class="delIcon">
                                                    <img class="delImg" src="../../../assets/images/workorder/delete.png">
                                                </div>
                                            </div>
                                            <div>
                                                <el-select
                                                    v-model="addpersonSelect"
                                                    placeholder="请选择"
                                                    clearable
                                                    style="width: 96%">
                                                    <el-option
                                                            v-for="item in accountPerson.list"
                                                            :key="item._id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="addTemplateTwo">
                                    <div class="addTemFollow">

                                        <div class="addTemFollowIcon">
                                            <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position: absolute;left: 50%"/>
                                        </div>
                                        <div class="addTemFollowContain">
                                            <div class="FollowManage">
                                                <div style="font-size: 14px">关注人</div>
                                                <div>
                                                    <el-checkbox v-model="focuCheck">必填</el-checkbox>
                                                </div>
                                                <div class="delIcon">
                                                    <img class="delImg" src="../../../assets/images/workorder/delete.png">
                                                </div>
                                            </div>
                                            <div class="addTemFollowSelect">
                                                <el-select
                                                    v-model="addFollowSelect"
                                                    placeholder="请选择"
                                                    multiple
                                                    style="width: 96%;">
                                                    <el-option
                                                            v-for="item in accountFocusPerson.list"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id">
                                                    </el-option>
                                                </el-select>

                                            </div>

                                        </div>


                                    </div>


                                    <div class="addTempriority">

                                        <div class="addTemPriorityIcon">
                                            <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position: absolute;left: 50%"/>
                                        </div>
                                        <div class="addTemPriorityContain">
                                            <div class="priorityManage">
                                                <div style="font-size: 14px">优先级</div>
                                                <div>
                                                    <el-checkbox v-model="priorityCheck" disabled>必填</el-checkbox>
                                                </div>
                                                <div class="delIcon">
                                                    <img class="delImg" src="../../../assets/images/workorder/delete.png">
                                                </div>
                                            </div>
                                            <div class="addTemPrioritySelect">
                                                <el-select v-model="addTempriority" placeholder="请选择" style="width: 96%;">
                                                    <el-option
                                                            v-for="item in prioritySelect"
                                                            :key="item.value"
                                                            :label="item.label"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-select>

                                            </div>
                                        </div>

                                    </div>
                                    <div class="addTemplateStatus">

                                        <div class="addTemStatusIcon">
                                            <img src="../../../assets/images/workorder/adjust1.png" style="height: 16px;width: 16px;position: absolute;left: 50%"/>
                                        </div>
                                        <div class="addTemstatusContain">
                                            <div class="statusManage">
                                                <div style="font-size: 14px">状态</div>
                                                <div>
                                                    <el-checkbox v-model="statusCheck" disabled>必填</el-checkbox>
                                                </div>
                                                <div class="delIcon">
                                                    <img src="../../../assets/images/workorder/delete.png" class="delImg"/>
                                                </div>
                                            </div>
                                            <div class="addTemplateStatus">
                                                <el-select v-model="addTemstatus" placeholder="请选择" style="width: 96%;">
                                                    <el-option
                                                            v-for="item in status.list"
                                                            :key="item.id"
                                                            :value="item.id"
                                                            :label="item.name"
                                                    >
                                                    </el-option>
                                                    <!-- <el-option value="尚未受理" label="尚未受理" style="background-color: #D9001B;color: white"></el-option>
                                                     <el-option value="受理中" label="受理中" style="background-color: #E1E600;color: white"></el-option>
                                                     <el-option value="已解决" label="已解决" style="background-color: #03B615;color: white"></el-option>
                                                     <el-option value="已关闭" label="已关闭" style="background-color: #D7D7D7;color: white"></el-option>-->
                                                </el-select>
                                            </div>


                                        </div>



                                    </div>


                                </div>
                            </div>


                   <div style="width: 80%;margin: 0 auto 20px auto;"
                        class="filedDefault" >

                       <div class="box" id="box">
                           <div
                                   class="cell"
                                   :class="getClass(item)"
                                   v-for="(item, index) in addTemplateFiled"
                                   :key="index"
                           >
                               <div v-if="item.field.type==='SELECT'">
                                   <div style="display: flex">
                                       <div class="adjuestImg2">
                                           <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                       </div>
                                       <div style="flex: 0.85 0.85 0;margin-left: 15px;width: 97%;">
                                           <div style=" display: flex;height: 32px;line-height: 32px; width: 97%;margin:0 auto;">
                                       <span style="flex: 1 1 0;text-align: left;">
                                           <div style="font-size: 14px;float: left" class="LongName">{{item.field.name}}</div>
                                            <div style="margin-left: 12px"> <el-checkbox v-model="item.required">必填</el-checkbox></div>

                                       </span>
                                               <div style="text-align: right;width: 17.2px;height: 16px">
                                                   <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-right: 5px;" @click="delSelect(index,item.field.id)"/>
                                               </div>
                                           </div>
                                           <div class="typeIsSelectSelect">
                                               <el-select v-model="item.defaultValue"
                                                          clearable
                                                          filterable
                                                          style="width: 96%;"
                                                          placeholder="请选择"
                                               >
                                                   <el-option
                                                           v-for="item in item.field.extInfo.exinfo"
                                                           :key="item.value"
                                                           :label="item.label"
                                                           :value="item.value"

                                                   >
                                                   </el-option>
                                               </el-select>
                                           </div>

                                       </div>
                                   </div>
                               </div>

                               <div v-if="item.field.type==='CASCADER'">
                                       <div  style="display: flex">
                                           <div class="adjuestImg2">
                                               <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                           </div>
                                           <div style="flex: 0.85 0.85 0;margin-left: 15px;width: 97%;">
                                               <div style="display: flex;width: 97%;margin: 0 auto;line-height: 32px;">
                                                   <div style=" flex: 1 1 0;overflow: hidden">
                                                       <div style="font-size: 14px;float: left;margin-right: 10px" class="LongName">{{item.field.name}}</div>
                                                       <div style="margin-left: 12px;"> <el-checkbox v-model="item.required">必填</el-checkbox></div>
                                                   </div>
                                                   <div style="height: 16px;text-align: right">
                                                       <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;" @click="cascadeClick2(index,item.field.id)"/>
                                                   </div>
                                               </div>
                                               <div>
                                                   <el-cascader
                                                           v-model="item.defaultValue"
                                                           :options="item.field.extInfo.cascadeDown[0].options"
                                                           @change="handleChange"
                                                           style="width: 96%"
                                                   ></el-cascader>
                                               </div>
                                           </div>
                                       </div>
                                   </div>

                               <div v-if="item.field.type==='DATE_PICKER'" >
                                   <div style="display: flex"
                                   >
                                       <div class="adjuestImg2">
                                           <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                       </div>
                                       <div class="fieldIsDatePicker">
                                           <div style="text-align: right;display: flex;width: 97%;margin:0 auto">
                                               <div style="flex: 1 1 0;text-align: left;height: 32px;line-height: 32px">
                                                   <div style="font-size: 14px;float: left;margin-right: 10px" class="LongName"> {{item.field.name}}</div>
                                                   <div style="margin-left: 12px"> <el-checkbox v-model="item.required">必填</el-checkbox></div>

                                               </div>
                                               <div style="text-align: right;width: 17.2px">
                                                   <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;margin-right: 5px" @click="dateClick(index,item.field.id)"/>
                                               </div>
                                           </div>
                                           <div style="width: 100%;margin: 0 auto">
                                               <el-date-picker
                                                       v-model="item.defaultValue"
                                                       type="date"
                                                       placeholder="选择日期"
                                                       style="width: 96%"
                                               >
                                               </el-date-picker>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                               <div v-if="item.field.type==='TIME_PICKER'" >
                                   <div style="display: flex">
                                       <div
                                            style=" flex: 0.15 0.15 0;
                                             position: relative;"
                                       >
                                           <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                       </div>
                                       <div class="fieldIsTimePicker">
                                           <div style="text-align: right;display: flex;width: 97%;margin:0 auto">
                                               <div style="flex: 1 1 0;text-align: left;height: 32px;line-height: 32px;">
                                                   <div style="font-size: 14px;float: left;margin-right: 10px" class="LongName">{{item.field.name}}</div>
                                                   <div style="margin-left: 12px"> <el-checkbox v-model="item.required">必填</el-checkbox></div>

                                               </div>
                                               <div style="text-align: right;width: 17.2px">
                                                   <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;margin-right: 5px" @click="timeClick(index,item.field.id)"/>
                                               </div>
                                           </div>
                                           <div style="width: 100%;margin: 0 auto">
                                               <el-time-picker
                                                       v-model="item.defaultValue"
                                                       placeholder="任意时间点"
                                                       style="width: 96%"
                                               >
                                               </el-time-picker>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                               <div v-if="item.field.type==='INPUT'" style="display: flex;width: 100%">

                                       <div class="adjuestImg">
                                           <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                       </div>
                                       <div class="typeIsSingeText">
                                           <div class="addTemplateSingeText">
                                       <span style="flex: 1 1 0;text-align: left">
                                           <span style="font-size: 14px">{{item.field.name}}</span>
                                            <span style="margin-left: 12px"> <el-checkbox v-model="item.required">必填</el-checkbox></span>
                                       </span>
                                               <div style="width: 17.2px;height: 16px;margin-right: 5px">
                                                   <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;" @click="singeClick(index,item.field.id)"/>
                                               </div>
                                           </div>
                                           <div class="typeIsSingeTextInput" style="margin-right: 10px">
                                               <el-input
                                                       placeholder="请输入单行文本的内容"
                                                       v-model="item.defaultValue"
                                                       clearable
                                                       style="width:100%;"
                                               >
                                               </el-input>
                                           </div>
                                       </div>
                               </div>
                               <div v-if="item.field.type==='TEXTAREA'" style="width: 100%;display: flex">

                                       <div class="adjuestImg">
                                           <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                       </div>
                                       <div class="typeIsTextarea">
                                           <div  class="typeIsTextareaText">
                                       <span style="margin-top: 10px;flex: 1 1 0;text-align: left">
                                           <span style="font-size: 14px">{{item.field.name}}</span>
                                           <span style="margin-left: 12px"> <el-checkbox v-model="item.required">必填</el-checkbox></span>

                                       </span>
                                               <div style="text-align: right;width: 17.2px;margin-right: 5px">
                                                   <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;" @click="textareaClick(index,item.field.id)"/>
                                               </div>

                                           </div>
                                           <div class="typeIsTextareaInput" style="margin-right: 10px;">
                                               <el-input
                                                       type="textarea"
                                                       :rows="2"
                                                       placeholder="请输入多行文本的内容"
                                                       v-model="item.defaultValue"
                                                       style="width: 100%;"
                                               >
                                               </el-input>
                                           </div>

                                       </div>


                               </div>

                               <div v-if="item.field.type==='RADIO'" style="display: flex;width: 100%">

                                       <div class="adjuestImg">
                                           <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 45%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                       </div>
                                       <div class="fieldRadioOptions">
                                           <div style="text-align: right;display: flex;margin:0 auto 10px auto">
                                       <span style="margin-top: 10px;flex: 1 1 0;text-align: left;white-space: nowrap">
                                          <span style="font-size: 14px"> {{item.field.name}}</span>
                                           <span style="margin-left: 12px"> <el-checkbox v-model="item.required">必填</el-checkbox></span>
                                       </span>
                                               <div style="text-align: right;width: 17.2px;height: 16px;margin-right: 5px">
                                                   <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;" @click="radioClick(index,item.field.id)"/>
                                               </div>
                                           </div>
                                           <div style="margin: 20px auto 0 auto">
                                               <el-radio-group v-model="item.defaultValue" style="background-color: whitesmoke">
                                                   <el-radio
                                                           v-for="(item,index) in item.field.extInfo.exinfo"
                                                           :label="item.value"
                                                           :key="index"
                                                           :value="item.value"
                                                           style="margin-right: 24px"
                                                           @change="changeRadio"
                                                   ></el-radio>


                                               </el-radio-group>
                                           </div>
                                       </div>

                               </div>
                               <div v-if="item.field.type==='CHECKBOX'" style="width: 100%;display: flex">

                                           <div class="adjuestImg">
                                               <img src="../../../assets/images/workorder/moveAdjust.png" style="width: 16px;height: 16px;position: absolute;top: 45%;left: 50%;cursor: move" @mouseenter="userDrop"/>
                                           </div>
                                           <div class="fieldCheckOptions">
                                               <div style="text-align: right;display: flex;margin:0 auto 10px auto">
                                       <span style="margin-top: 10px;flex: 1 1 0;text-align: left">
                                            <span style="font-size: 14px">{{item.field.name}}</span>
                                            <span style="margin-left: 12px"> <el-checkbox v-model="item.required">必填</el-checkbox></span>

                                       </span>
                                                   <div style="text-align: right;width: 17.2px;margin-right: 5px">
                                                       <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;" @click="checkBoxClick(index,item.field.id)"/>
                                                   </div>
                                               </div>
                                               <div style="margin: 20px auto 0 auto">
                                                   <el-checkbox-group v-model="item.defaultValue">
                                                       <el-checkbox
                                                               v-for="(items,index) in item.field.extInfo.exinfo"
                                                               :label="items.value"
                                                               :key="index"
                                                               style="margin-right: 24px"
                                                               @change="changeCheckbox"
                                                       >{{items.value}}</el-checkbox>
                                                   </el-checkbox-group>
                                               </div>
                                           </div>
                                   </div>

                                   <!--<div v-if="item.field.type === 'CASCADER'">级联：{{ item.field.name }}</div>
                                   <div v-if="item.field.type === 1">客户：{{ item.field.name }}</div>
                                   <div v-if="item.field.type === 2">级联：{{ item.field.name }}</div>-->

                           </div>
                       </div>




                   </div>
                            <!--<div id="defaultCascade">
                                <div v-for="(item,index) in defaultCascadeList1" :key="item.id">
                                    <div class="filedTypeIsCascade">
                                        <div class="adjuestImg"
                                             style=" flex: 0.05 0.05 0;
                                    position: relative;"
                                        >
                                            <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px;position: absolute;top: 50%;left: 50%;cursor: move" @mouseenter="resortTemplat" @click="aaa"/>
                                        </div>
                                        <div style="flex: 0.95 0.95 0" >
                                            <div style="width: 98%;margin: 0 auto 0 15px">
                                                <div style="display: flex">
                                                    <div style="line-height: 32px; flex: 1 1 0;">
                                                        <span style="font-size: 14px">{{item.name}}</span>
                                                        <span style="margin-left: 12px"> <el-checkbox v-model="defaultFieldCascade[index]">必填</el-checkbox></span>
                                                    </div>
                                                    <img src="../../../assets/images/fieldmanage/delred.png" style="width: 16px;height: 16px;margin-top: 10px;margin-right: 5px" @click="cascadeClick(index,item.id)"/>
                                                </div>

                                                <div style="display: flex;justify-content: space-between;">
                                                    <div style="width: 30%">
                                                        <el-select v-model="value1[index]"
                                                                   placeholder="请选择"
                                                                   style="width:90%;"
                                                                   @change="optionssClick(index,value1[index])"

                                                        >
                                                            <el-option
                                                                    v-for="(item,indexs) in item.extInfo.cascadeDown[0].options"
                                                                    :label="item.label"
                                                                    :value="item.value"
                                                                    :key="indexs">

                                                            </el-option>
                                                        </el-select>
                                                    </div>
                                                    <div style="width: 30%;text-align: center">
                                                        <el-select v-model="value2[index]"
                                                                   placeholder="请选择"
                                                                   style="width:90%;"
                                                                   @change="optionssChildrenChange(index,value2[index])"
                                                        >
                                                            <el-option
                                                                    v-for="(item,indexss) in optionssChildren[index]"
                                                                    :key="indexss"
                                                                    :label="item.label"
                                                                    :value="item.value"
                                                            ></el-option>
                                                            &lt;!&ndash;   <el-option value="朝阳区" label="朝阳区">
                                                               </el-option>
                                                               <el-option value="海淀区" label="海淀区">
                                                               </el-option>&ndash;&gt;
                                                        </el-select>
                                                    </div>
                                                    <div style="width: 30%;text-align: right;margin-right: 8px">
                                                        <el-select v-model="value3[index]"
                                                                   placeholder="请选择"
                                                                   style="width: 90%"


                                                        >
                                                            <el-option
                                                                    v-for="(item,indexsss) in children[index]"
                                                                    :key="indexsss"
                                                                    :value="item.value"
                                                                    :label="item.label"
                                                            ></el-option>
                                                        </el-select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>-->
                   </div>
                </el-scrollbar>
            </div>
            </div>
    </div>
</template>

<script>
    import VueUeditorWrap from 'vue-ueditor-wrap'
    import SideBar from "../../workorder/sidebar/SideBar";
    import Sortable from "sortablejs";
    export default {
        name: "AddTemplate",
        components: {SideBar,VueUeditorWrap},
            data() {
                return {
                    templateName: '',
                    templateDescribe:'',
                    inputName:'',
                    checked:true,
                    checked1:true,
                    addTemplateDescribe:'',
                     addCustomSelect:'',
                    addgroupSelect:'',
                    addpersonSelect:'',
                    addTempriority:'',
                    prioritySelect:[
                      {
                        value:'URGENT',
                        label:'紧急'
                      },
                      {
                        value:'HIGH',
                        label:'高'
                      },
                      {
                        value:'MIDDLE',
                        label:'中'
                      },
                      {
                        value:'LOW',
                        label:'低'
                      }
                    ],
                    addFollowSelect:[],

                    addTemstatus:'',
                    myConfig: {
                        autoHeightEnabled: false, // 编辑器不自动被内容撑高
                        initialFrameHeight: 200, // 初始容器高度
                        initialFrameWidth: '98%', // 初始容器宽度
                        UEDITOR_HOME_URL: ' /ueditor/',
                        serverUrl: "/ueditor-api/",
                        //上传文件的接口
                        enableAutoSave: false,
                        elementPathEnable: false,
                        wordCount: false,
                        autoFloatEnabled:false,
                        imageScaleEnabled:false,
                        toolbars: [
                            [
                                'undo', //撤销
                                'bold', //加粗
                                'indent', //首行缩进
                                'italic', //斜体
                                'underline', //下划线
                                'strikethrough', //删除线
                                'subscript', //下标
                                'superscript', //上标
                                'formatmatch', //格式刷
                                'fontfamily', //字体
                                'fontsize', //字号
                                'justifyleft', //居左对齐
                                'justifycenter', //居中对齐
                                'justifyright', //居右对齐
                                'justifyjustify', //两端对齐
                                'insertorderedlist', //有序列表
                                'insertunorderedlist', //无序列表
                                'forecolor', //字体颜色
                                'backcolor', //背景色
                                'lineheight',//行间距
                                'link', //超链接
                                'simpleupload', //单图上传
                                'insertvideo', //视频
                                'attachment', //附件上传
                                'fullscreen'
                            ]
                        ],
                        'fontfamily':[
                            { label:'',name:'songti',val:'宋体,SimSun'},
                            { label:'仿宋',name:'fangsong',val:'仿宋,FangSong'},
                            { label:'仿宋_GB2312',name:'fangsong',val:'仿宋_GB2312,FangSong'},
                            { label:'',name:'kaiti',val:'楷体,楷体_GB2312, SimKai'},
                            { label:'',name:'yahei',val:'微软雅黑,Microsoft YaHei'},
                            { label:'',name:'heiti',val:'黑体, SimHei'},
                            { label:'',name:'lishu',val:'隶书, SimLi'},
                            { label:'',name:'andaleMono',val:'andale mono'},
                            { label:'',name:'arial',val:'arial, helvetica,sans-serif'},
                            { label:'',name:'arialBlack',val:'arial black,avant garde'},
                            { label:'',name:'comicSansMs',val:'comic sans ms'},
                            { label:'',name:'impact',val:'impact,chicago'},
                            { label:'',name:'timesNewRoman',val:'times new roman'}
                        ],
                    },
                    filed:{
                        list:[]
                    },
                    singeText:[],
                    textarea:[],
                    selectValue:[],
                    selectList:[],
                    inputType:0,
                    textareaType:0,
                    selectType:0,
                    cascadeType:0,
                    radioType:0,
                    checkBoxType:0,
                    datePickerType:0,
                    timePickerType:0,
                    checkList:[],
                    radioCheck:{
                        list:['选项1','选项2']
                    },
                    radio:[],
                    timeCheck:[],
                    dateCheck:[],
                    client:{
                        list:[]
                    },
                    accountGroup:{
                        list:[]
                    },
                    accountPerson:{
                        list:[]
                    },
                  accountGroupPerson:{
                      list:[]
                  },
                    status:{
                        list:[]
                    },
                    addTemplateFiled:[],
                    selectFiledId:0,
                    selectRequired:false,
                    inputFiledId:0,
                    inputRequired:false,
                    textareaFiledId:0,
                    textareaRequired:false,
                    radioFiledId:0,
                    radioRequired:false,
                    checkBoxFiledId:0,
                    checkBoxRequired:false,
                    datePickerFiledId:0,
                    datePickerRequired:false,
                    timePickerFiledId:0,
                    timePickerRequired:false,
                    cascadeFiledId:0,
                    cascadeFiledRequired:false,
                    modifyTemplate:{},
                    defaultFiled:{
                        list:[]
                    },
                    value:'',
                    addTemDatePickerList:[],
                    addTemTimePickerList:[],
                    addTemFieldSelectList:[],
                    addTemFieldCheckBoxList:[],
                    addTemFieldRadioList:[],
                    inputSingeTextList:[],
                    textareaTextList:[],
                    defaultSelectList:[],
                    defaultCascadeList:[],
                    defaultCascadeList1:[],
                    defaultCascadeList2:[],
                    defaultRadioList:[],
                    defaultCheckList:[],
                    defaultTimeList:[],
                    defaultDateList:[],
                    fieldTwoDimensionalList:{
                            fieldId: '',
                            required: false,
                            width: 0
                    },
                    fieldTwoDimensional:[],
                    aaaaaaa:[],
                    style:0,
                    cascader:[],
                    fieldResort:[],
                    statusCheck:true,
                    focuCheck:false,
                    priorityCheck:true,
                    customerCheck:false,
                    groupCheck:false,
                    personCheck:false,
                    value1:[],
                    value2:[],
                    value3:[],
                    options:[],
                    optionss:[],
                    optionssChildren:[],
                    children:[],
                    secondeOption:[],
                    thirdeOption:[],
                    defaultFieldCascade:[],
                    defaultFieldSingele:[],
                    defaultFieldSelect:[],
                    defaultFieldRadio:[],
                    defaultFieldCheck:[],
                    defaultFieldDate:[],
                    defaultFieldTime:[],
                    defaultFieldCascade2:[],
                    defaultFieldTextarea:[],
                    allDefaultField:[],
                    accountFocusPerson:{
                        list:[]
                    }
                }
            },
        mounted() {
              this.getTemplateId()
             this.getClientList()
             this.getAccountGroup()
          this.$nextTick(()=>{
            this.getAccountPerson(this.addgroupSelect)
          })

            this.getStatus()
            this.getFocuesAccountPerson()
          this.addTempriority='MIDDLE'


        },
        methods: {
          changeCheckbox(value){
            console.log(value)
          },
          changeRadio(value){
            console.log(value)
          },
            userDrop() {
                // 此时找到的元素是要拖拽元素的父容器
                const box = document.getElementById('box')
                const _this = this;
                new Sortable(box, {
                    ghostClass: 'blue-background-class',
                    animation: 500,
                    sort: true,
                    onUpdate: function (event) {
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = box.children[newIndex],
                            $oldLi = box.children[oldIndex];
                        // 先删除移动的节点
                        box.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if (newIndex > oldIndex) {
                            box.insertBefore($li, $oldLi)
                        } else {
                            box.insertBefore($li, $oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.addTemplateFiled.splice(oldIndex, 1)
                        _this.addTemplateFiled.splice(newIndex, 0, item[0])
                        // 下一个tick就会走patch更新

                    },


                });
                this.addTemplateFiled=  _this.addTemplateFiled
            },
            getClass(item){

                if(item.field.type==='CASCADER'||item.field.type==='SELECT'||item.field.type==='DATE_PICKER'||item.field.type==='TIME_PICKER')
                    return 'cell-manag'
                else if(item.field.type==='INPUT'||item.field.type==='RADIO'||item.field.type==='CHECKBOX')
                    return 'cell-user'
                else if(item.field.type==='TEXTAREA')
                    return 'cell-textarea'
            },
            //增加工单模板
            addWorkOrderTemplate() {
             this.fieldTwoDimensional=[]
              console.log(this.addTemplateFiled)
                this.addTemplateFiled.forEach(item=> {
                    const fieldTwoDimensionalList = {}
                    fieldTwoDimensionalList.fieldId = item.field.id
                    fieldTwoDimensionalList.required = item.required
                    fieldTwoDimensionalList.width = 0
                   fieldTwoDimensionalList.defaultValue=item.defaultValue
                /*  fieldTwoDimensionalList.defaultValue={}
                    if(this.addTemplateFiled[index].field.type ==='INPUT')
                    {
                      fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.singeText[index]
                    }
                  if(this.addTemplateFiled[index].field.type ==='TEXTAREA')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.textarea[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='RADIO')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.radio[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='CHECKBOX')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.checkList[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='TIME_PICKER')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.timeCheck[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='DATE_PICKER')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.dateCheck[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='CASCADER')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.cascader[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='SELECT')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.selectValue[index]
                  }
                    this.fieldTwoDimensional.push(fieldTwoDimensionalList)*/
                  this.fieldTwoDimensional.push(fieldTwoDimensionalList)

                })
              console.log(this.fieldTwoDimensional)

                let defaultFieldInfos=[];
                defaultFieldInfos.push({key:"clientId",name:"客户",required:this.customerCheck,defaultValue:this.addCustomSelect});
                defaultFieldInfos.push({key:"assigneeGroupId",name:"受理组",required:this.groupCheck,defaultValue:this.addgroupSelect});
                defaultFieldInfos.push({key:"assigneeId",name:"受理人",required:this.personCheck,defaultValue:this.addpersonSelect});
                defaultFieldInfos.push({key:"followersId",name:"关注人",required:this.focuCheck,defaultValue:this.addFollowSelect});
              defaultFieldInfos.push({key:"themeName",name:"主题",required:true,defaultValue:this.inputName});
              defaultFieldInfos.push({key:"themeDescribe",name:"主题描述",required:true,defaultValue:this.addTemplateDescribe});
              defaultFieldInfos.push({key:"priority",name:"优先级",required:true,defaultValue:this.addTempriority});
              defaultFieldInfos.push({key:"status",name:"状态",required:true,defaultValue:this.addTemstatus});
               console.log(defaultFieldInfos)
                 if(this.templateName!=='')
                {
                    console.log(this.fieldTwoDimensional)
                    this.$http.post('/api/template', {
                        description: this.templateDescribe,
                        name: this.templateName,
                        workOrderFieldList: {
                            fieldTwoDimensionalList: [
                                this.fieldTwoDimensional
                            ]
                        },
                        defaultFieldList:{
                            defaultFieldInfos:defaultFieldInfos
                        }
                    }).then(res => {
                        if (res.data.code === '0') {
                            this.$message.success('保存工单模板成功')
                            setTimeout( ()=> {
                                this.$router.push('/workordertemlate')
                            },500)


                        } else {
                            this.$message('保存工单模板失败')
                        }
                    })
                    this.fieldTwoDimensional = []
                }
                else
                    this.$message.error('请填写模板名称')

            },
            getDefaultFieldList(){

            },
            //修改工单
            modifyWorkOrderTemplate() {
                this.fieldTwoDimensional=[]
                this.addTemplateFiled.forEach((item) => {
                    const fieldTwoDimensionalList = {}
                    fieldTwoDimensionalList.fieldId = item.field.id
                    fieldTwoDimensionalList.required = item.required
                    fieldTwoDimensionalList.width = 0
                    fieldTwoDimensionalList.defaultValue=item.defaultValue
                  this.fieldTwoDimensional.push(fieldTwoDimensionalList)
                 /* fieldTwoDimensionalList.defaultValue={}
                  if(this.addTemplateFiled[index].field.type ==='INPUT')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.singeText[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='TEXTAREA')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.textarea[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='RADIO')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.radio[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='CHECKBOX')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.checkList[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='TIME_PICKER')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.timeCheck[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='DATE_PICKER')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.dateCheck[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='CASCADER')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.cascader[index]
                  }
                  if(this.addTemplateFiled[index].field.type ==='SELECT')
                  {
                    fieldTwoDimensionalList.defaultValue[this.addTemplateFiled[index].field.id]=this.selectValue[index]
                  }
                    this.fieldTwoDimensional.push(fieldTwoDimensionalList)*/
                })
                let defaultFieldInfos=[];
                /*defaultFieldInfos.push({key:"clientId",name:"客户",required:this.customerCheck});
                defaultFieldInfos.push({key:"assigneeGroupId",name:"受理组",required:this.groupCheck});
                defaultFieldInfos.push({key:"assigneeId",name:"受理人",required:this.personCheck});
                defaultFieldInfos.push({key:"followersId",name:"关注人",required:this.focuCheck});*/
              defaultFieldInfos.push({key:"clientId",name:"客户",required:this.customerCheck,defaultValue:this.addCustomSelect});
              defaultFieldInfos.push({key:"assigneeGroupId",name:"受理组",required:this.groupCheck,defaultValue:this.addgroupSelect});
              defaultFieldInfos.push({key:"assigneeId",name:"受理人",required:this.personCheck,defaultValue:this.addpersonSelect});
              defaultFieldInfos.push({key:"followersId",name:"关注人",required:this.focuCheck,defaultValue:this.addFollowSelect});
              defaultFieldInfos.push({key:"themeName",name:"主题",required:true,defaultValue:this.inputName});
              defaultFieldInfos.push({key:"themeDescribe",name:"主题描述",required:true,defaultValue:this.addTemplateDescribe});
              defaultFieldInfos.push({key:"priority",name:"优先级",required:true,defaultValue:this.addTempriority});
              defaultFieldInfos.push({key:"status",name:"状态",required:true,defaultValue:this.addTemstatus});
              if(this.templateName!=='')
                {
                  console.log(this.fieldTwoDimensional)
                    this.$http.put('/api/template/' + this.$route.query.id, {
                        description: this.templateDescribe,
                        name: this.templateName,
                        workOrderFieldList: {
                            fieldTwoDimensionalList: [this.fieldTwoDimensional]
                        },
                        defaultFieldList:{
                            defaultFieldInfos:defaultFieldInfos
                        }
                    }).then(res => {
                        if (res.data.code === '0') {
                            this.$message.success('修改工单模板成功')
                            setTimeout( ()=> {
                                this.$router.push('/workordertemlate')
                            },500)
                        } else {
                            this.$message.error('修改工单模板失败')
                        }
                    })
                    this.fieldTwoDimensional = []
                }
                else
                    this.$message.error('请添加工单模板名称')

            },
          //获取修改的工单模板
          getTemplateId() {
              this.addFollowSelect=[]
            this.checkList=[]
            if(this.$route.query.id!==undefined)
            {
              this.addTemplateFiled=[]
              this.$http.get('/api/template/' + this.$route.query.id).then(res => {
                this.modifyTemplate = res.data.data
                this.templateName = this.modifyTemplate.name
                this.templateDescribe = this.modifyTemplate.description
                if(this.modifyTemplate.workOrderFieldList!==null)
                {
                  this.modifyTemplate.workOrderFieldList.fieldTwoDimensionalList[0].forEach(item => {
                    this.addTemplateFiled.push(item)
                  })
                }
                console.log(this.addTemplateFiled)

                for (let i=0;i<this.addTemplateFiled.length;i++)
                {
                  this.checkList.push([])
                }
                for (let i=0;i<this.addTemplateFiled.length;i++)
                {
                  if(this.addTemplateFiled[i].field.type==='SELECT')
                  {
                    this.addTemplateFiled[i].field.extInfo.exinfo.forEach(item=>{
                      if(item._default==='true')
                        this.selectValue[i]=item.value
                    })
                  }

                }
                for (let i=0;i<this.addTemplateFiled.length;i++)
                {
                  if(this.addTemplateFiled[i].field.type==='RADIO')
                  {
                    this.addTemplateFiled[i].field.extInfo.exinfo.forEach(item=>{
                      if(item._default==='true')
                        this.radio[i]=item.value
                    })
                  }
                }
                for (let i=0;i<this.addTemplateFiled.length;i++)
                {
                  if(this.addTemplateFiled[i].field.type==='CHECKBOX')
                  {
                    this.$set(this.addTemplateFiled[i],'defaultValue',[])
                    this.addTemplateFiled[i].field.extInfo.exinfo.forEach(item=>{
                      if(item._default==='true')
                        this.addTemplateFiled[i].defaultValue.push(item.value)

                    })
                  }
                }
                this.$http.get('/api/field/list').then(res => {
                  this.filed.list = res.data.data
                  /*  let test=this.addTemplateFiled*/
                  let add=this.addTemplateFiled.filter(item=>!this.filed.list.some(ele=>ele.id===item.fieldId))
                  let add2=this.addTemplateFiled.filter(item=>!add.some(ele=>ele.fieldId===item.fieldId))
                  this.addTemplateFiled=add2
                  this.addTemplateFiled.forEach(item=>{
                    for (let i = 0; i < this.filed.list.length; i++) {
                      if (item.fieldId === this.filed.list[i].id) {
                        this.filed.list.splice(i, 1)
                      }
                    }
                  })
                })
                let defaultFieldList = this.modifyTemplate.defaultFieldList;
                console.log(defaultFieldList)
                if(defaultFieldList!=null){
                  let defaultFieldInfos=defaultFieldList.defaultFieldInfos;
                  if(defaultFieldInfos!=null&&defaultFieldInfos.length>0){
                    for(let i=0;i<defaultFieldInfos.length;i++){
                      let info=defaultFieldInfos[i];
                      if(info.key==='clientId'){
                        this.customerCheck=info.required;
                        if(info.defaultValue!==null)
                        {
                          this.addCustomSelect=info.defaultValue
                        }

                      }else if(info.key==='assigneeGroupId'){
                        this.groupCheck=info.required;
                        if(info.defaultValue!==null){
                          this.addgroupSelect=info.defaultValue
                          this.getAccountPerson(this.addgroupSelect)
                        }

                      }else if(info.key==='assigneeId'){
                        this.personCheck=info.required;
                        if(info.defaultValue!==null){
                          this.addpersonSelect=info.defaultValue
                        }
                      }else if(info.key==='followersId'){
                        this.focuCheck=info.required;
                        if(info.defaultValue!==null){
                          this.addFollowSelect=info.defaultValue
                        }
                      }else if(info.key ==='priority')
                      {
                        this.addTempriority=info.defaultValue
                      }else if(info.key ==='status')
                      {
                        if(info.defaultValue!==null){
                          this.addTemstatus=info.defaultValue
                        }
                      }else if(info.key ==='themeName')
                      {
                        if(info.defaultValue!==null){
                          this.inputName=info.defaultValue
                        }
                      }else if(info.key ==='themeDescribe')
                      {
                        if(info.defaultValue!==null){
                          this.addTemplateDescribe=info.defaultValue
                        }

                      }
                    }
                  }
                  console.log(this.customerCheck,this.groupCheck,this.personCheck,this.focuCheck);
                }
              })
            }
            else
            {
              this.$http.get('/api/field/list').then(res => {
                this.filed.list = res.data.data
              })
            }
          },
            backOrdrTemplate() {
                this.$router.back()
            },
            noClick() {

            },
            closeClick() {
                this.$router.push('workordertemlate')
            },
            unique() {
                const res = new Map();
                return this.filed.list.filter((item) => !res.has(item.id) && res.set(item.id, 1));
            },
            unique2() {
                const res = new Map();
                return this.fieldTwoDimensional.filter((item) => !res.has(item.id) && res.set(item.id, 1));
            },
            //获取字段
            getFiledList() {
                this.$http.get('/api/field/list').then(res => {
                    this.filed.list = res.data.data
                })
            },
            //获取客户
            getClientList() {
                this.$http.get('/api/client/page').then(res => {
                    this.client.list = res.data.data.content
                })
            },
            //获取受理组
            getAccountGroup() {
                this.$http.get('/api/account/group').then(res => {
                    this.accountGroup.list = res.data.data
                })
            },
            //获取受理人
            getAccountPerson(value) {
              console.log(value)
                    this.$http.get('/api/account/principal?groupId='+value).then(res => {
                        this.accountPerson.list = res.data.data
                    })
               /* }
                else
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res => {
                        this.accountPerson.list = res.data.data
                    })
                }*/

            },

            //获取关注人
            getFocuesAccountPerson() {

                    this.$http.get('/api/account/principal?groupId=%20').then(res => {
                        this.accountFocusPerson.list = res.data.data
                    })
            },
            //获取状态
            getStatus() {
                this.$http.get('/api/status/list').then(res => {
                    this.status.list = res.data.data
                  this.addTemstatus=this.status.list[0].id
                })
            },


            filedTypeClick(value, index, id, item) {
              this.checkList=[]
                this.filed.list.splice(index, 1)
                const filed = {
                    field: item,
                  defaultValue:null
                }
                this.addTemplateFiled.push(filed)
              console.log(this.addTemplateFiled)
              for (let i=0;i<this.addTemplateFiled.length;i++)
              {
                this.checkList.push([])
              }
              for (let i=0;i<this.addTemplateFiled.length;i++)
              {
                if(this.addTemplateFiled[i].field.type==='SELECT')
                {
                  this.addTemplateFiled[i].field.extInfo.exinfo.forEach(item=>{
                    if(item._default==='true')
                      this.addTemplateFiled[i].defaultValue=item.value
                  })
                }
              }
              for (let i=0;i<this.addTemplateFiled.length;i++)
              {
                if(this.addTemplateFiled[i].field.type==='RADIO')
                {
                  this.addTemplateFiled[i].field.extInfo.exinfo.forEach(item=>{
                    if(item._default==='true')
                      this.addTemplateFiled[i].defaultValue=item.value
                  })
                }

              }
              for (let i=0;i<this.addTemplateFiled.length;i++)
              {
                if(this.addTemplateFiled[i].field.type==='CHECKBOX')
                {
                  this.$set(this.addTemplateFiled[i],'defaultValue',[])
                  this.addTemplateFiled[i].field.extInfo.exinfo.forEach(item=>{
                    if(item._default==='true')
                      this.addTemplateFiled[i].defaultValue.push(item.value)

                  })
                  console.log( this.addTemplateFiled[i].defaultValue)
                }
              }
            },
            delSelect(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)
                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)
            },
            singeClick(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)
                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)
            },
            textareaClick(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)
                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)
            },
            dateClick(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)
                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)

            },
            timeClick(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)

                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)
            },
            radioClick(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)

                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)



            },
            checkBoxClick(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)

                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)


            },
            cascadeClick2(index, id) {
                this.filed.list.push(this.addTemplateFiled[index].field)

                if (this.addTemplateFiled[index].field.id === id)
                    this.addTemplateFiled.splice(index, 1)

            },
            handleChange(value) {
                console.log(value);
            },
            resortTemplat() {
                let _this = this;
                let el = document.getElementById('tttttt');
                new Sortable(el, {
                    ghostClass: 'blue-background-class',
                    animation: 500,
                    onUpdate: function (event) {
                        //修改items数据顺序
                        let newIndex = event.newIndex,
                            oldIndex = event.oldIndex,
                            $li = el.children[newIndex],
                            $oldLi = el.children[oldIndex];
                        // 先删除移动的节点
                        el.removeChild($li)
                        // 再插入移动的节点到原有节点，还原了移动的操作
                        if (newIndex > oldIndex) {
                            el.insertBefore($li, $oldLi)
                        } else {
                            el.insertBefore($li, $oldLi.nextSibling)
                        }
                        // 更新items数组
                        let item = _this.addTemplateFiled.splice(oldIndex, 1)
                        _this.addTemplateFiled.splice(newIndex, 0, item[0])
                        // 下一个tick就会走patch更新

                    },


                });
                /*Sortable.create(el, {
                    draggable: ".cell",
                    onEnd({ newIndex, oldIndex }) {
                        // 将 拖拽后的列表信息 存到 data变量中
                        console.log(newIndex, oldIndex);
                        data = _this.addTemplateFiled;
                    },
                });
                // 将 data变量中的 信息 赋值给 tableData 重新渲染列表数据
                if (!data) {
                    this.addTemplateFiled = data;
                    console.log(this.addTemplateFiled)
                }*/
                /*Sortable.create(el, {
                    draggable: ".cell",
                    onEnd({ newIndex, oldIndex }) {
                        // 将 拖拽后的列表信息 存到 data变量中
                        console.log(newIndex, oldIndex);
                        data = _this.addTemplateFiled;
                    },
                });
                // 将 data变量中的 信息 赋值给 tableData 重新渲染列表数据
                if (!data) {
                    this.addTemplateFiled = data;
                }*/
               /* this.addTemplateFiled=_this.addTemplateFiled*/
                console.log(_this.addTemplateFiled)
               /* this.defaultCascadeList2 = _this.addTemplateFiled*/


            },
            optionssClick(index,value){
                console.log(index,value)
                this.defaultCascadeList1.forEach(item=>{
                    item.extInfo.cascadeDown[0].options.forEach(items=>{
                        if(items.value===value)
                        {
                            if(items.children!==undefined)
                            {
                                this.optionssChildren[index]=items.children

                            }
                        }

                    })

                })
              /*  this.optionssChildren.children=[]
                console.log(value)
                console.log(this.value1)
                this.options.forEach(item=>{
                    if(item.value===value)
                        this.optionssChildren.children=item.children
                })*/

               /* this.optionss.forEach(item=>{
                    if(item.value===value)
                        this.optionssChildren.children=item.children
                })*/
            },
            optionssChildrenChange(index,value){
                console.log(index,value)
                console.log(this.optionssChildren[index])
                this.optionssChildren[index].forEach(item=>{
                    console.log(item)
                    if(item.value===value)
                    {
                        if(item.children!==undefined)
                        {
                            this.children[index]=item.children
                        }

                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
@import "../../../assets/less/workordertemplate/addtemplate/addtemplate";
.el-scrollbar__wrap{
    overflow-x: hidden;
}
.blue-background-class{
    background-color: #409EFF;
}
.box {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-right: -10px;
}
.cell {
    cursor: pointer;
    margin-bottom: 20px;
}
.cell-user {
    flex: none;

    width: 98.5%;
    height: 96px;
    background-color: #F2F2F2;
    display: flex;
    float: left;
    margin-bottom: 20px;
}
.cell-textarea{
    width: 98.5%;
    height: 115px;
    background-color: #F2F2F2;
    display: flex;
    float: left;
    margin-bottom: 20px;
}
.cell-manag {

    flex: none;
    width: calc(33.33% - 10px);
    height: 96px;
    background-color: #F2F2F2;
    margin-bottom: 20px;
    border-right: 10px solid white;
}
</style>